var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-modal-alert"},[_c('div',{staticClass:"f-modal-icon f-modal-error animate"},[_c('span',{staticClass:"f-modal-x-mark"},[_c('span',{staticClass:"f-modal-line f-modal-left animateXLeft"}),_c('span',{staticClass:"f-modal-line f-modal-right animateXRight"})]),_c('div',{staticClass:"f-modal-placeholder"}),_c('div',{staticClass:"f-modal-fix"})])])
}]

export { render, staticRenderFns }